module.exports = __webpack_public_path__ + "static/img/grid3.562ac32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grid3.png
// module id = si6Z
// module chunks = 0